<template>
  <div id="app" class="component" :data-site="currentRoute">
    <AddonBookingHeader></AddonBookingHeader>
    <Cart></Cart>
    <!-- <div class="currently-down" v-if="SITE_CONFIG.site === 'branas'">
      <p>Idag onsdag den 21:a augusti är bokningen stängd över både webb och telefon.</p>
    </div> -->
    <router-view></router-view>
    <div v-if="currentModal" :is="currentModal.component" :params="getCurrentModal"></div>
    <div v-if="getCurrentTimeoutModal" :is="currentTimeoutModal.component" :params="getCurrentTimeoutModal"></div>
    <div class="dropdown-background"></div>
    <div class="cart-background"></div>
    <div v-if="$store.state.isDebugging" @click="$store.state.isDebugging = false" class="debugging">
      API: {{apiUrl}} &nbsp; &nbsp; &nbsp; &nbsp;
      <button v-for="lang in languages" class="small" @click.stop="setLanguage(lang)">{{lang}}</button>
    </div>
    <WebFooter v-if="!$store.state.isOnSite" />
    <div v-if="SITE_CONFIG.env !== 'production' && SITE_CONFIG.is_production" class="production-mode-alert">
      ⚠️ Produktionsläge ⚠️
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import API from '@/classes/API';

import Cart from '@/components/parts/Cart';
import AddonBookingHeader from '@/components/parts/AddonBookingHeader';
import Modals from '@/components/modals';

import WebFooter from '@/components/components/WebFooter';

function updateBodyModalAwareness(modal) {
  if (modal) {
    document.body.classList.add('modal-opened');
  } else {
    document.body.classList.remove('modal-opened');
  }
}

export default {
  name: 'app',
  components: {
    Cart,
    ...Modals,
    WebFooter,
    AddonBookingHeader,
  },
  mounted() {
    this.refreshFavorites();
    this.refreshCart();
    this.closeAllModals();
    this.closeTimeoutModal();
    this.dontAwaitFilter();

    if (!this.$store.state.user_code) {
      this.setUserCode(this.makeid());
    }

    if (this.SITE_CONFIG.env === 'local') {
      this.startEnvironmentCheck();
    }
  },
  methods: {
    ...mapMutations([
      'refreshFavorites',
      'refreshCart',
      'closeTimeoutModal',
      'closeAllModals',
      'dontAwaitFilter',
      'setUserCode',
    ]),
    startEnvironmentCheck() {
      setInterval(async () => {
        try {
          const res = await API.get('config/env-check');
          if (res.is_production !== this.SITE_CONFIG.is_production) {
            window.location.reload();
          }
        } catch (e) {
          // Silent catch
        }
      }, 5000);
    },
    async setLanguage(lang) {
      localStorage.setItem('language', lang);

      const data = await API.get('translations');
      try {
        this.$i18n.setLocaleMessage(lang.value, data.translations);
      } catch (e) {
        console.log(e);
      }

      window.SITE_CONFIG.translations = data.translations;

      try {
        this.$i18n.locale = lang;
      } catch (e) {
        console.log(e);
      }

      document.querySelector('html').setAttribute('lang', lang);
    },
    makeid() {
      let text = '';
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (var i = 0; i < 12; i++) { // eslint-disable-line
        text += possible.charAt(Math.floor(Math.random() * possible.length)); // eslint-disable-line
      }

      return text;
    },
  },
  computed: {
    ...mapGetters([
      'currentModal',
      'currentTimeoutModal',
    ]),
    languages() {
      const langs = [];
      langs.push(this.SITE_CONFIG.languages.default);
      this.SITE_CONFIG.languages.other.forEach((lang) => {
        langs.push(lang);
      });
      return langs;
    },
    getCurrentModal() {
      updateBodyModalAwareness(this.currentModal);
      return this.currentModal;
    },
    getCurrentTimeoutModal() {
      updateBodyModalAwareness(this.currentModal);
      return this.currentTimeoutModal;
    },
    currentRoute() {
      return (this.$route.meta.cssPage || this.$route.name || '').toLowerCase().replace(/[^a-z0-9]/g, '-');
    },
    apiUrl() {
      return window.API_URL;
    },
  },
};
</script>

<style lang="stylus">
@import './main.styl'
</style>

<style lang="stylus">
body.modal-opened
  overflow hidden
  max-height: 100vh
  width: 100%
  // position fixed
#app
  min-height 80vh
  background-color white
  font-family: Interstate;
  font-weight: 300

label
  display: block;
  margin-bottom: 5px;
  font-weight: 700;

input
  line-height: normal

input[type=email], input[type=tel], input[type=text], input[type=password], textarea, select
  border: 1px solid #bfbfbf;
  border-radius: 0;
  padding: .5em;
  outline: 0;
  width: 100%!important;
  font-size: 14px;

h1,
h2,
h3,
h4,
h5,
h6,
ol,
ul,
p
  margin-top 0
  padding-top 0
  padding-bottom 0

h1, h2, h3, h4, h5, h6, p
  margin-bottom: 10px;

h4, h5, h6
  margin-top 10px

body .popper[x-placement^="right"] .popper__arrow {
  border-width: 10px 10px 10px 0;
  border-color: transparent #262626 transparent transparent;
  left: -20px;
  top: calc(50% - 20px);
  margin-left: 0;
  margin-right: 0;
  margin: 10px;
}
body .popper[x-placement^="right"] {
  margin-left: 15px;
  border-radius: 2px;
}

#cookie-notice,
#tvx-customer-widget,
#tvx-customer-widget *,
#snapifyWrapper,
#imboxNewMsgNotification,
#snapifyHiddenContentA,
#snapWrap,
._hj-widget-container
  display none !important
</style>

<style lang="stylus">
@import '~@/global.styl'

div[data-site="ski-rental"],
div[data-site="ski-school"],
div[data-site="ski-pass"]
  .info-content
    max-width 656px
    margin 60px auto 35px auto
    +max-mobile()
      padding 0 padding-mobile
    h2
      united-heavy()
      uppercase()
      centered()
      font-size size-font-headline
      color #262626
      font-size size-font-headline-small
      margin-top 45px
      margin-bottom 20px
    /*.clickable,
    .cardsrow,
    p
      max-width 656px
      margin 0 auto*/
    p
      font-size size-font-3
      margin-bottom 1em


      .items-list
        max-width 980px
        margin 0 auto

        .item
          display: flex
          justify-content: space-between
          flex-gutter: 1em
          background-color: white
          box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.13)
          padding: 15px 17px
          cursor: pointer
          margin-bottom: space-3
          flex-wrap: wrap;
          +max-mobile()
            padding: 8px 8px 15px;
          ul
            ul-with-checkboxes()

  ul
    ul-with-checkboxes()

  .offer-box
    p
      font-size 16px
      font-weight 300
      line-height 1.3
      color #262626
      margin-top 15px
      margin-bottom 15px
</style>

<style lang="stylus" scoped>
@import '~@/global.styl'

.currently-down
  info-box()
  info-box--blue()
  max-width: 650px
  text-align: center
  margin: 30px auto
  margin-top 50px

.dropdown-background,
.cart-background
  position: fixed;
  top: 0;
  width: 0;
  height: 0;
.dropdown-opened--with-background .dropdown-background,
.cart-opened--with-background .cart-background
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.8);
  overflow: auto;
.cart-opened--with-background .cart-background
  z-index: 8;

.debugging
  position: fixed;
  background-color pink
  bottom 0
  left 0
  width 100%
  height 10px
  color black
  font-size 8px
  uppercase()
  z-index 100001
  text-align center
  line-height 10px
  padding 0
  button
    padding 0 4px

.component
  // background-color white

.production-mode-alert
  position fixed
  bottom 0
  left 0
  width 100%
  background linear-gradient(90deg, #ff9100, #ffa200)
  color #111111
  text-align center
  font-weight bold
  font-size 13px
  padding 8px 16px
  z-index 9999999
  box-shadow 0 -2px 10px rgba(0,0,0,0.3)
  font-family system-ui, -apple-system, sans-serif
  letter-spacing 0.5px
</style>



// WEBPACK FOOTER //
// App.vue?142644ea